<template>
<div class="row">
    <loading v-if="loading"></loading>
    <template v-if="!loading">
        <div class="col-xs-10">
            <h1>{{ t.ebooks }}</h1>
        </div>
        <div class="col-xs-2" v-if="false && config.data.owner">
            <a class="btn btn-primary pull-right" href="#" v-collapse="'#addEbook'">
                {{ t.add_ebook }}
            </a>
        </div>
        <div class="col-xs-12">
            <div v-if="false" id="addEbook" class="col-md-6 col-md-offset-3" ref="addForm">
                <form @submit.prevent="submit" @keydown="validate($event.target.name)" @change="validate($event.target.name)">
                    <p>{{ t.enter_amazon_or_smashwords }}</p>
                    <SiteInput :label="t.url" type="url" :form="form" v-model="form.url" name="url"></SiteInput>
                    <button class="btn btn-primary pull-right">
                        <span v-if="!formLoading">{{ gt.common.add }}</span>
                        <loading v-if="formLoading" :small="true"></loading>
                    </button>
                </form>
            </div>
            <div class="clearfix"></div>
            <Ebook v-for="ebook in ebooks" :book="ebook" :key="ebook.id">
                <div class="dropdown pull-right" slot="dropdown">
                    <button type="button" class="btn btn-xs" v-dropdown>
                        <i class="fa fa-chevron-down"></i>
                    </button>
                    <ul class="dropdown-menu">
                        <li><a href="#" @click.prevent="refresh(ebook)">{{ t.refresh }}</a></li>
                        <li role="separator" class="divider"></li>
                        <li><a href="#" @click.prevent="deleteEbook(ebook)">{{ gt.common.delete }}</a></li>
                    </ul>
                </div>
            </Ebook>
            <p v-if="!ebooks.length">{{ t.no_ebooks }}</p>
        </div>
    </template>
</div>
</template>

<script>
import ajax from 'Site/js/util/ajax.fetch';
import collapseDirective from 'Site/directive/collapse';
import dropdownDirective from 'Site/directive/dropdown';
import Ebook from 'Stories/component/Ebook.vue';
import Form from 'Site/js/util/form';
import Loading from 'Site/component/Loading.vue';
import SiteInput from 'Site/component/SiteInput.vue';
import SiteSelect from 'Site/component/SiteSelect.vue';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'ProfileEbooks',
    components: {
        Ebook,
        Loading,
        SiteInput,
        SiteSelect
    },
    computed: {
        ...mapState(['config', 'gt'])
    },
    data() {
        return {
            ebooks: [],
            form: new Form({
                type: 'amazon',
                url: ''
            }, {
                url: [
                    { type: 'required' },
                    {
                        type: 'pattern',
                        pattern: /(amazon)|(smashwords)/i,
                        inverse: true,
                        message: this.$store.state.t.amazon_or_smashwords
                    }
                ]
            }),
            formLoading: false,
            loading: true,
            pages: {},
            t: {}
        };
    },
    directives: {
        collapse: collapseDirective,
        dropdown: dropdownDirective
    },
    created() {
        const setData = (settings) => {
            settings = JSON.parse(settings);
            this.ebooks = settings.data.ebooks;
            this.t = Object.assign(settings.translate, this.$store.state.t);
            this.loading = false;
        };
        if (document.querySelector('#ebooks-json')) {
            const settings = document.querySelector('#ebooks-json').textContent;
            if (settings) {
                setData(settings);
            }
        } else {
            ajax.get(window.location.href).then((data) => {
                setData(data);
            });
        }
    },
    methods: {
        ...mapActions(['notify', 'showConfirm']),
        deleteEbook(ebook) {
            this.showConfirm({
                text: this.t.confirm_ebook_delete,
                callback: () => {
                    ajax.delete('ebooks', { id: ebook.id }).then(() => {
                        this.ebooks = this.ebooks.filter(textBook => textBook !== ebook);
                    });
                }
            });
        },
        refresh(ebook) {
            ajax.update('ebooks', { id: ebook.id }).then(({ item, message }) => {
                this.ebooks = this.ebooks.filter(textBook => textBook !== ebook);
                this.ebooks.push(item);
                this.notify({ msg: message });
            });
        },
        validate(field) {
            this.form.errors.clear(field);
            this.form.validate(field);
        },
        submit() {
            const form = this.form.create('ebooks');
            if (form) {
                this.formLoading = true;
                form.then((response) => {
                    this.ebooks.unshift(response.item);
                    this.formLoading = false;
                    this.$refs.addForm.classList.remove('in');
                });
            }
        }
    }
};

</script>
